import type { ModalComponentProps } from "@/lib/modal";
import { ConfirmationModal } from "@/components/modals/confirmation-modal";
import { useDeleteInvite } from "@/lib/api/teams";
import type { TeamInvite } from "@/lib/api/types";

export interface DeleteInviteModalProps {
  tenantId: string;
  invite: TeamInvite;
}

export function DeleteInviteModal({
  tenantId,
  invite,
  onClose,
}: DeleteInviteModalProps & ModalComponentProps) {
  const deleteInvite = useDeleteInvite(tenantId);

  const handleDelete = () => {
    deleteInvite.mutate(invite.id, {
      onSuccess: () => onClose(),
    });
  };

  return (
    <ConfirmationModal
      title="Delete invitation"
      description="Are you sure you want to delete this invitation? The link will no longer work."
      confirmLabel="Delete"
      pendingLabel="Deleting..."
      onConfirm={handleDelete}
      isPending={deleteInvite.isPending}
      onClose={onClose}
    />
  );
}

DeleteInviteModal.displayName = "DeleteInviteModal";
